<b3-modal
  class="emission-reject-modal"
  [open]="open"
  overlay
  size="sm"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Análise da Emissão"
    aria-level="2"
    icon="cancel"
    icon-tone="danger"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <div class="emission-reject-modal__body">
      <b3-ds-radio-group
        name="emission-reject-action"
        [(ngModel)]="selectedAction"
        [options]="[{ value: 'correction', label: 'Solicitar correção' }]">
      </b3-ds-radio-group>

      <b3-input-text
        inputId="emission-reject-project-name"
        label="Nome do Projeto"
        background="grey"
        [(ngModel)]="projectNameValue"
        [disabled]="true">
      </b3-input-text>

      <div class="emission-reject-modal__comment">
        <b3-input-area
          inputId="emission-reject-comment"
          label="Comentário"
          background="grey"
          placeholder="Inserir comentário"
          [(ngModel)]="comment"
          (ngModelChange)="onCommentChange($event)"
          [maxlength]="commentMaxLength"
          [error]="commentError">
        </b3-input-area>
        <p
          class="emission-reject-modal__character-count"
          [class.emission-reject-modal__character-count--limit]="commentLength >= commentMaxLength">
          {{ commentLength }}/{{ commentMaxLength }}
        </p>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="emission-reject-modal__footer">
      <b3-button type="button" variant="outlined" tone="default" (b3-click)="onCancel()">
        Cancelar
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" (b3-click)="onConfirm()">
        <b3-icon name="check_circle"></b3-icon>
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
